
    import "/home/git/waysglob/website/src/components/classroom/index.module.scss.FARM_CSS_MODULES?e27fe49f";
    
    export default {"wrapper": `wrapper-3bf85b47`,"title-wrapper": `title-wrapper-3bf85b47`,"items-wrapper": `items-wrapper-3bf85b47`}
    